var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundActive = function SvgBackgroundActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 25.5C41.85 25.5 40.5 26.85 40.5 28.5V34.5H19.5V28.5C19.5 26.85 18.15 25.5 16.5 25.5C14.85 25.5 13.5 26.85 13.5 28.5V36C13.5 38.475 15.525 40.5 18 40.5V42C18 42.825 18.675 43.5 19.5 43.5C20.325 43.5 21 42.825 21 42V40.5H39V42C39 42.825 39.675 43.5 40.5 43.5C41.325 43.5 42 42.825 42 42V40.5C44.475 40.5 46.5 38.475 46.5 36V28.5C46.5 26.85 45.15 25.5 43.5 25.5Z",
    fill: "#00A5B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.5V31.5H37.5V28.5C37.5 25.71 39.42 23.385 42 22.71V21C42 18.525 39.975 16.5 37.5 16.5H22.5C20.025 16.5 18 18.525 18 21V22.71C20.58 23.385 22.5 25.71 22.5 28.5Z",
    fill: "#00A5B9"
  })));
};
export default SvgBackgroundActive;